<!-- Release Overview Section -->
<app-release-overview [companyId]="selectedCompany?.id" [isDarkModeInput]="isDarkMode"></app-release-overview>

<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="center center" fxLayout="column">
    <div fxFlex="100" class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search releases by name</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="filterData()"
          (keyup.esc)="searchTerm=''; filterData()"
          name="searchTerm"
          placeholder="Search Name">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; filterData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field class="accent">
        <mat-label>Filter by status</mat-label>
        <mat-select [(value)]="statusFilter" (selectionChange)="filterByStatus($event.value)">
          <mat-option [value]="undefined">All Statuses</mat-option>
          <mat-option *ngFor="let status of availableStatuses" [value]="status.value">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <div class="chart-select-color" [style.background-color]="status.color"></div>
              <span>{{ status.name }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="filterData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button
            [matTooltip]="(data.data?.length > 0 ? 'Add Release' : 'Add Release to get started!')"
            mat-flat-button color="accent" (click)="addRelease()">
            <mat-icon>add</mat-icon> Add Release
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <small *ngIf="!onlyActiveFilter && statusFilter === undefined" class="text-warning">
          no filters currently applied
        </small>
        <mat-chip-list>
          <mat-chip *ngIf="onlyActiveFilter" (click)="filterOnlyActive(undefined)">
            <span>Showing only Active releases</span>
            <button matChipRemove (click)="filterOnlyActive(undefined)">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="!onlyActiveFilter" (click)="filterOnlyActive(true)">
            <span>Show only Active releases</span>
            <button matChipRemove (click)="filterOnlyActive(true)">
              <mat-icon color="accent" matTooltip="Filter">filter_alt</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="statusFilter !== undefined" (click)="filterByStatus(undefined)">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
              <div class="chart-select-color" [style.background-color]="getStatusInfo(statusFilter).color"></div>
              <span>Status: {{ getStatusInfo(statusFilter).name }}</span>
            </div>
            <button matChipRemove (click)="filterByStatus(undefined)">
              <mat-icon color="primary" matTooltip="Clear status filter">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="isSituUser" class="contrast banner-success m-t-20" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="30" fxLayoutAlign="center start" fxLayout="column" fxLayoutGap="2px">
      <strong [ngClass.lt-sm]="{'card-title': true}">Released</strong>
      <small>Items that have already been released</small>
    </div>
    <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row">
        <button mat-icon-button color="accent" aria-label="Edit Release" matTooltip="Edit Release" (click)="onClickRelease(undefined, 'complete')">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="isSituUser" class="contrast banner-info" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="30" fxLayoutAlign="center start" fxLayout="column" fxLayoutGap="2px">
      <strong [ngClass.lt-sm]="{'card-title': true}">Top 100</strong>
      <small>Top 100 homes viewed in the past week</small>
    </div>
    <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row">
        <button mat-icon-button color="accent" aria-label="Edit Release" matTooltip="Edit Release" (click)="onClickRelease(undefined, 'top100')">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="contrast" *ngFor="let item of filteredData; let i = index; trackBy: trackByReleaseId" [ngClass.lt-sm]="{'mat-card-inline-sm': true}" [class.banner-warning]="isExpired(item.releaseDate)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="30" fxLayoutAlign="center start" fxLayout="column" fxLayoutGap="2px">
      <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="2px">
        <strong [ngClass.lt-sm]="{'card-title': true}" matTooltip="{{ (isExpired(item.releaseDate) ? 'Stopped processing ' : 'Processing until ' )}}{{ item.releaseDate | date:'short' }}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm"></strong>
        <div *ngIf="item?.renderReleaseStatus != null" class="chart-select-color" 
          [style.background-color]="getStatusInfo(item.renderReleaseStatus).color" 
          [style.cursor]="'pointer'"
          [matTooltip]="'Status: ' + getStatusInfo(item.renderReleaseStatus).name + ' (click to filter)'"
          (click)="filterByStatus(item.renderReleaseStatus); $event.stopPropagation()"></div>
        <mat-icon [matTooltip]="item.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'Pre-Release - Changes to home files are being actively monitored and updated' : 'Pre-Release - Off'" *ngIf="item.renderReleaseStatus === renderReleaseStatuses.PreRelease" color="accent">science</mat-icon>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
        <small *ngIf="item?.description">{{ item.description }}</small>
        <mat-icon [class.link]="item?.situRaytracedPlus" 
          [class.disable-link]="!item?.situRaytracedPlus" 
          [matTooltip]="item?.situRaytracedPlus ? productNames[productNames.RayTracedPlus] + ' renders enabled' : productNames[productNames.RayTracedPlus] + ' renders not enabled'" 
          [style.color]="getProductColour(productNames.RayTracedPlus)">panorama</mat-icon>
        <mat-icon [class.link]="item?.situPlan" 
          [class.disable-link]="!item?.situPlan" 
          [matTooltip]="item?.situPlan ? 'situPLAN renders enabled' : 'situPLAN renders not enabled'" 
          [style.color]="getProductColour(productNames.Plan)">foundation</mat-icon>
        <mat-icon [class.link]="item?.situRender" 
          [class.disable-link]="!item?.situRender" 
          [matTooltip]="item?.situRender ? 'situRENDER renders enabled' : 'situRENDER renders not enabled'" 
          [style.color]="getProductColour(productNames.Render)">photo_camera</mat-icon>
      </div>
    </div>
    <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
      <div *ngIf="!isExpired(item.releaseDate)" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <span class="position-number">{{ i + 1 }}</span>
        <div fxLayout="column" fxLayoutGap="0" class="priority-controls">
          <button mat-icon-button class="priority-arrow" 
            [disabled]="!canMoveUp(item)" 
            (click)="adjustPriority(item, 'up')"
            matTooltip="Move up in priority">
            <mat-icon>arrow_drop_up</mat-icon>
          </button>
          <button mat-icon-button class="priority-arrow" 
            [disabled]="!canMoveDown(item)" 
            (click)="adjustPriority(item, 'down')"
            matTooltip="Move down in priority">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="item?.total !== null && item?.totalLive !== null" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="2px">
        <small>Total Live</small>
        <small matTooltip="Total Live / Total Release Items">{{ item?.totalLive }} / <span [class.text-warning]="item.totalLive < item.total" [class.text-success]="item.totalLive === item.total">{{ item?.total }}</span></small>
      </div>
      <div *ngIf="item?.totalRendered !== null" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="2px">
        <small>Total Rendered</small>
        <small matTooltip="Total Renders During the Release"><span class="text-info">{{ item?.totalRendered }}</span></small>
      </div>
      <div fxLayoutAlign="end center" fxLayout="row">
        <button mat-icon-button color="accent" aria-label="Edit Release" matTooltip="Edit Release" (click)="onClickRelease(item)">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>